
import Logo, { ReactComponent as LogoW } from './logo.svg';
import Logosolo, { ReactComponent as LogosoloW } from './logosolito.svg';
import Carga, { ReactComponent as CargaW } from './carga.svg';
import LogoClear, { ReactComponent as LogoClearW } from './logoClear.svg';
import LogoWhite, { ReactComponent as LogoWhiteW } from './logoWhite.svg';
import BackArrow, { ReactComponent as BackArrowW } from './backArrow.svg';
import Inicio, { ReactComponent as InicioW } from './i-inicio.svg';
import Explorar, { ReactComponent as ExplorarW } from './i-explorar.svg';
import Login, { ReactComponent as LoginW } from './i-login.svg';
import MenuFavoritos, { ReactComponent as MenuFavoritosW } from './i-favorito.svg';
import MenuPedido, { ReactComponent as MenuPedidoW } from './i-pedido.svg';
import IconChecked, { ReactComponent as IconCheckedw } from './iconChecked.svg';
import IconCheckedOk, { ReactComponent as IconCheckedOkW } from './iconCheckedOk.svg';
import KMenu, { ReactComponent as KMenuW } from './menu.svg';
import BtnMas, { ReactComponent as BtnMasW } from './btnMas.svg';
import Menos, { ReactComponent as MenosW } from './menos.svg';
import Mas, { ReactComponent as MasW } from './mas.svg';
import Right, { ReactComponent as RightW } from './i-right.svg';
import Camara, { ReactComponent as CamaraW } from './camara.svg';
import Categoria, { ReactComponent as CategoriaW } from './categoria.svg';
import Home, { ReactComponent as HomeW } from './home.svg';
import Perfil, { ReactComponent as PerfilW } from './perfil.svg';
import Password, { ReactComponent as PasswordW } from './password.svg';
import InputEmail, { ReactComponent as InputEmailW } from './inputEmail.svg';
import InputPhone, { ReactComponent as InputPhoneW } from './inputPhone.svg';
import IProductos, { ReactComponent as IProductosW } from './iProductos.svg';

import Mconf, { ReactComponent as MconfW } from './m-conf.svg';
import Minicio, { ReactComponent as MinicioW } from './m-inicio.svg';
import Mexit, { ReactComponent as MexitW } from './m-exit.svg';
import Mnotify, { ReactComponent as MnotifyW } from './m-notify.svg';
import Msuport, { ReactComponent as MsuportW } from './m-suport.svg';
import Mcontact, { ReactComponent as McontactW } from './m-contact.svg';
import Message, { ReactComponent as MessageW } from './message.svg';
import Cola, { ReactComponent as ColaW } from './cola.svg';
import Tienda, { ReactComponent as TiendaW } from './tienda.svg';
import Empleados, { ReactComponent as EmpleadosW } from './empleados.svg';
import Zonas, { ReactComponent as ZonasW } from './zonas.svg';
import Clientes, { ReactComponent as ClientesW } from './clientes.svg';
import Carrito2, { ReactComponent as Carrito2W } from './carrito.svg';
import Delete2, { ReactComponent as Delete2W } from './delete2.svg';
import Delete3, { ReactComponent as Delete3W } from './delete3.svg';

import Check, { ReactComponent as CheckW } from './check.svg';
import Imap, { ReactComponent as ImapW } from './map.svg';
import Icompras, { ReactComponent as IcomprasW } from './icompras.svg';
import Ipedidos, { ReactComponent as IpedidosW } from './ipedidos.svg';
import ImaxCompra, { ReactComponent as ImaxCompraW } from './imaxCompra.svg';
import IminCompra, { ReactComponent as IminCompraW } from './iminCompra.svg';
import Ilast, { ReactComponent as IlastW } from './ilast.svg';
import Ifirst, { ReactComponent as IfirstW } from './ifirst.svg';
import Ieliminar, { ReactComponent as IeliminarW } from './ieliminar.svg';
import Iclients, { ReactComponent as IclientsW } from './iclients.svg';
import Iventas, { ReactComponent as IventasW } from './iventas.svg';
import Izonas, { ReactComponent as IzonasW } from './izonas.svg';
import MarcadorMapa, { ReactComponent as MarcadorMapaW } from './marcadorMapa.svg';
import MPedido, { ReactComponent as MPedidoW } from './mPedido.svg';
import IConductores, { ReactComponent as IConductoresW } from './iConductores.svg';
import MProductos, { ReactComponent as MProductosW } from './mProductos.svg';
import VendedorIcon, { ReactComponent as VendedorIconW } from './vendedorIcon.svg';
import Trasnportista, { ReactComponent as TrasnportistaW } from './trasnportista.svg';
import MProductoMasV, { ReactComponent as MProductoMasVW } from './mProductoMasV.svg';
import MconPedidos, { ReactComponent as MconPedidosW } from './mconPedidos.svg';
import MsinPedidos, { ReactComponent as MsinPedidosW } from './msinPedidos.svg';
import MListUser, { ReactComponent as MListUserW } from './mListUser.svg';
import MSinPedidosMap, { ReactComponent as MSinPedidosMapW } from './mSinPedidosMap.svg';
import MConPedidosMap, { ReactComponent as MConPedidosMapW } from './mConPedidosMap.svg';
import MVisit, { ReactComponent as MVisitW } from './mVisit.svg';
import Icamera, { ReactComponent as IcameraW } from './icamera.svg';
import IconPedido, { ReactComponent as IconPedidoW } from './iconPedido.svg';
import VisitSi, { ReactComponent as VisitSiW } from './visitSi.svg';
import VisitNo, { ReactComponent as VisitNoW } from './visitNo.svg';
import SinUbicacion, { ReactComponent as SinUbicacionW } from './sinUbicacion.svg';
import IconoPedido, { ReactComponent as IconoPedidoW } from './iconoPedido.svg';
import IconTerminos, { ReactComponent as IconTerminosW } from './iconTerminos.svg';
import IconLocation, { ReactComponent as IconLocationW } from './iconLocation.svg';
import InputDireccion, { ReactComponent as InputDireccionW } from './inputDireccion.svg';
import Icarnet, { ReactComponent as IcarnetW } from './icarnet.svg';
import Icategoria, { ReactComponent as IcategoriaW } from './icategoria.svg';
import Ireload, { ReactComponent as IreloadW } from './ireload.svg';
import Istorage, { ReactComponent as IstorageW } from './istorage.svg';
import Ientregas, { ReactComponent as IentregasW } from './ientregas.svg';
import Ilist, { ReactComponent as IlistW } from './ilist.svg';
import Iuser, { ReactComponent as IuserW } from './iuser.svg';
import Isave, { ReactComponent as IsaveW } from './isave.svg';
import Scroll, { ReactComponent as ScrollW } from './scroll.svg';
import Ivendedor, { ReactComponent as IvendedorW } from './ivendedor.svg';
import Iactivo, { ReactComponent as IactivoW } from './iactivo.svg';
import Id1, { ReactComponent as Id1W } from './id1.svg';
import Id2, { ReactComponent as Id2W } from './id2.svg';
import Id3, { ReactComponent as Id3W } from './id3.svg';
import Id4, { ReactComponent as Id4W } from './id4.svg';
import Iactivot, { ReactComponent as IactivotW } from './iactivot.svg';
import Idt1, { ReactComponent as Idt1W } from './idt1.svg';
import Idt2, { ReactComponent as Idt2W } from './idt2.svg';
import Idt3, { ReactComponent as Idt3W } from './idt3.svg';
import Idt4, { ReactComponent as Idt4W } from './idt4.svg';
import Entregado, { ReactComponent as EntregadoW } from './entregado.svg';
import NoEntregado, { ReactComponent as NoEntregadoW } from './noEntregado.svg';
import NoEntregado2, { ReactComponent as NoEntregado2W } from './noEntregado2.svg';





const Assets = {

	"Logo": { Native: Logo, Web: LogoW },
	"Logosolo": { Native: Logosolo, Web: LogosoloW },
	"Carga": { Native: Carga, Web: CargaW },
	"LogoWhite": { Native: LogoWhite, Web: LogoWhiteW },
	"LogoClear": { Native: LogoClear, Web: LogoClearW },
	"BackArrow": { Native: BackArrow, Web: BackArrowW },
	"Inicio": { Native: Inicio, Web: InicioW },
	"Explorar": { Native: Explorar, Web: ExplorarW },
	"Login": { Native: Login, Web: LoginW },
	"MenuFavoritos": { Native: MenuFavoritos, Web: MenuFavoritosW },
	"MenuPedido": { Native: MenuPedido, Web: MenuPedidoW },

	"IconChecked": { Native: IconChecked, Web: IconCheckedw },
	"IconCheckedOk": { Native: IconCheckedOk, Web: IconCheckedOkW },
	"KMenu": { Native: KMenu, Web: KMenuW },
	"BtnMas": { Native: BtnMas, Web: BtnMasW },
	"Menos": { Native: Menos, Web: MenosW },
	"Mas": { Native: Mas, Web: MasW },
	"Right": { Native: Right, Web: RightW },
	"Camara": { Native: Camara, Web: CamaraW },
	"Categoria": { Native: Categoria, Web: CategoriaW },
	"Home": { Native: Home, Web: HomeW },
	"Perfil": { Native: Perfil, Web: PerfilW },
	"InputEmail": { Native: InputEmail, Web: InputEmailW },
	"InputPassword": { Native: Password, Web: PasswordW },
	"InputPhone": { Native: InputPhone, Web: InputPhoneW },

	"Mconf": { Native: Mconf, Web: MconfW },
	"Minicio": { Native: Minicio, Web: MinicioW },
	"Mexit": { Native: Mexit, Web: MexitW },
	"Mnotify": { Native: Mnotify, Web: MnotifyW },
	"Msuport": { Native: Msuport, Web: MsuportW },
	"Mcontact": { Native: Mcontact, Web: McontactW },
	"Message": { Native: Message, Web: MessageW },
	"Cola": { Native: Cola, Web: ColaW },
	"Tienda": { Native: Tienda, Web: TiendaW },
	"Empleados": { Native: Empleados, Web: EmpleadosW },
	"Zonas": { Native: Zonas, Web: ZonasW },
	"Clientes": { Native: Clientes, Web: ClientesW },
	"Carrito2": { Native: Carrito2, Web: Carrito2W },
	"Delete2": { Native: Delete2, Web: Delete2W },
	"Delete3": { Native: Delete3, Web: Delete3W },
	"Check2": { Native: Check, Web: CheckW },
	"Imap": { Native: Imap, Web: ImapW },
	"Icompras": { Native: Icompras, Web: IcomprasW },
	"Ipedidos": { Native: Ipedidos, Web: IpedidosW },
	"ImaxCompra": { Native: ImaxCompra, Web: ImaxCompraW },
	"IminCompra": { Native: IminCompra, Web: IminCompraW },
	"Ilast": { Native: Ilast, Web: IlastW },
	"Ifirst": { Native: Ifirst, Web: IfirstW },
	"Ieliminar": { Native: Ieliminar, Web: IeliminarW },
	"Iclients": { Native: Iclients, Web: IclientsW },
	"Iventas": { Native: Iventas, Web: IventasW },
	"Izonas": { Native: Izonas, Web: IzonasW },
	"MarcadorMapa": { Native: MarcadorMapa, Web: MarcadorMapaW },
	"MPedido": { Native: MPedido, Web: MPedidoW },
	"IConductores": { Native: IConductores, Web: IConductoresW },
	"MProductos": { Native: MProductos, Web: MProductosW },
	"Vendedor": { Native: VendedorIcon, Web: VendedorIconW },
	"Trasnportista": { Native: Trasnportista, Web: TrasnportistaW },
	"MProductoMasV": { Native: MProductoMasV, Web: MProductoMasVW },
	"MconPedidos": { Native: MconPedidos, Web: MconPedidosW },
	"MsinPedidos": { Native: MsinPedidos, Web: MsinPedidosW },
	"MListUser": { Native: MListUser, Web: MListUserW },
	"MSinPedidosMap": { Native: MSinPedidosMap, Web: MSinPedidosMapW },
	"MConPedidosMap": { Native: MConPedidosMap, Web: MConPedidosMapW },
	"MVisit": { Native: MVisit, Web: MVisitW },
	"Icamera": { Native: Icamera, Web: IcameraW },
	"IconPedido": { Native: IconPedido, Web: IconPedidoW },
	"VisitSi": { Native: VisitSi, Web: VisitSiW },
	"VisitNo": { Native: VisitNo, Web: VisitNoW },
	"SinUbicacion": { Native: SinUbicacion, Web: SinUbicacionW },
	"IconoPedido": { Native: IconoPedido, Web: IconoPedidoW },
	"IconTerminos": { Native: IconTerminos, Web: IconTerminosW },
	"IconLocation": { Native: IconLocation, Web: IconLocationW },
	"IProductos": { Native: IProductos, Web: IProductosW },
	"InputDireccion": { Native: InputDireccion, Web: InputDireccionW },
	"Icarnet": { Native: Icarnet, Web: IcarnetW },
	"Icategoria": { Native: Icategoria, Web: IcategoriaW },
	"Ireload": { Native: Ireload, Web: IreloadW },
	"Istorage": { Native: Istorage, Web: IstorageW },
	"Ientregas": { Native: Ientregas, Web: IentregasW },
	"Ilist": { Native: Ilist, Web: IlistW },
	"Iuser": { Native: Iuser, Web: IuserW },
	"Isave": { Native: Isave, Web: IsaveW },
	"Scroll": { Native: Scroll, Web: ScrollW },
	"Ivendedor": { Native: Ivendedor, Web: IvendedorW },
	"Iactivo": { Native: Iactivo, Web: IactivoW },
	"Id1": { Native: Id1, Web: Id1W },
	"Id2": { Native: Id2, Web: Id2W },
	"Id3": { Native: Id3, Web: Id3W },
	"Id4": { Native: Id4, Web: Id4W },
	"Iactivot": { Native: Iactivot, Web: IactivotW },
	"Idt1": { Native: Idt1, Web: Idt1W },
	"Idt2": { Native: Idt2, Web: Idt2W },
	"Idt3": { Native: Idt3, Web: Idt3W },
	"Idt4": { Native: Idt4, Web: Idt4W },
	"Entregado": { Native: Entregado, Web: EntregadoW },
	"NoEntregado": { Native: NoEntregado, Web: NoEntregadoW },
	"NoEntregado2": { Native: NoEntregado2, Web: NoEntregado2W },
	
	
	












}

export default Assets;